import type { ResolvableServicePage_MaterialUsagesList_MaterialUsage } from '..';

export const getRowId = (
  row: ResolvableServicePage_MaterialUsagesList_MaterialUsage,
) => row.material._id;
